<template>

<div>



<!--     <div class="navbar-produtos">

        <a class="btn btn-primary" data-toggle="collapse" href="#collapseExample" role="button" aria-expanded="false" aria-controls="collapseExample">
            Categorias
        </a>

        <div class="collapse" id="collapseExample">
            <div class="card m-2 card-body">
                <div
                    role="group"
                    aria-label="Basic example"
                >


                    <router-link
                        v-for="categoria in categorias" :key="categoria.id"
                        :to="'#cat'+categoria.id"
                        tag="button"
                        class="btn btn-secondary m-1"
                    >
                        {{categoria.nome}}

                    </router-link>

                </div>

            </div>
        </div>

    </div> -->

    <div class="row navbar-produtos mt-3 px-3 py-1 justify-content-between b-bg">
        <button class="btn b-btn btn-lg" @click="openMenu">Categorias</button>
        <div class="form-inline w-50">
        <div class="input-group m-0">
          <input class="form-control form-control-lg mr-2 rounded" type="text" placeholder="Procurar" v-model="campo_busca" v-on:keyup.enter="pesquisar(campo_busca)">
          <button type="button" class="btn b-btn btn-lg"><i class="fas fa-search" @click="pesquisar(campo_busca)"></i></button>
        </div>
        </div>
    </div>

    <Drawer class="drawer" :direction="'left'" :exist="true" ref="LeftDrawer">
        <div class="row my-4 titulo-categoria">
            <h3 >Categorias</h3>
        </div>
        <ul>
            <li v-if="promocoes.length > 0" >
                <router-link
                    to="#catPromocoes"
                    tag="button"
                    class="btn b-btn btn-lg m-1"
                >
                    <span @click="openMenu" >Promoções</span>
                </router-link>
            </li>
            <li v-if="clones.length > 0" >
                <router-link
                    to="#catClonePizza"
                    tag="button"
                    class="btn b-btn btn-lg m-1"
                >
                    <span @click="openMenu" >Clones</span>
                </router-link>
            </li>
            <li v-if="pizzas.length > 0" >
                <router-link
                    to="#catPizza"
                    tag="button"
                    class="btn b-btn btn-lg m-1"
                >
                    <span @click="openMenu" >Pizzas</span>
                </router-link>
            </li>
            <li v-for="categoria in categorias" :key="categoria.id" >
                <router-link

                    :to="'#cat'+categoria.id"
                    tag="button"
                    class="btn b-btn btn-lg m-1"
                >
                    <span @click="openMenu" >{{categoria.nome}}</span>
                </router-link>
            </li>
        </ul>
    </Drawer>

    <div v-if="!carregando_cat">

        <!-- ------------------------------------------------------------------------------------------------------------------------------------------------------ -->
        <!-- ----------------------------------------------------------------  RESULTADO DA BUSCA  ---------------------------------------------------------------- -->
        <!-- ------------------------------------------------------------------------------------------------------------------------------------------------------ -->

        <div
            v-if="busca!=''"
            class="pt-3 body-bd"
        >
            <div class="row my-4 titulo-categoria">
                <h3 >Resultado da Busca</h3>
            </div>
            <div class="row mx-0 productlist" >
                <div
                    v-for="produto in produtos.filter(produto => (filtrarProduto(produto.nome)||(produto.descricao?filtrarProduto(produto.descricao):false))&&produto.categoria.disponivel==1)"
                    :key="produto.id"
                    class="col-lg-6 px-1 my-1"
                >
                    <a @click="modalAddCarrinho(produto)">
                        <div class="card p-2">
                            <div class="d-flex flex-row" style="height:100%">
                                <div v-if="produto.imagem_url" class="p-1 align-self-center">
                                    <img class="img-thumb" :src="produto.imagem_url" style="max-height: 72px ; max-width: 72px" >
                                </div>
                                <div class="p-1">
                                    <h6>{{produto.nome}}</h6>
                                    <span style="font-weight:normal; font-size:12px">{{produto.descricao}}</span>
                                </div>
                                <div class="p-1 ml-auto" >
                                    <div class="d-flex flex-column justify-content-end" style="width:80px; height:100%">
                                        <span v-if="produto.promocao" class="badge badge-pill badge-danger align-self-center mb-auto">Em Promoção</span>
                                        <del v-if="produto.promocao" class="align-self-center mb-2">R$ {{formatarMoeda(produto.valor)}}</del>
                                        <span v-if="produto.promocao" class="align-self-center">R$ {{formatarMoeda(produto.promocao.valor)}}</span>
                                        <span v-else class="align-self-center">R$ {{formatarMoeda(produto.valor)}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>

                <div
                        v-for="pizza in pizzas.filter(pizza => (filtrarProduto(pizza.nome)||(pizza.descricao?filtrarProduto(pizza.descricao):false)))"
                        :key="pizza.id"
                        class="col-lg-12 px-1 my-1"
                    >

                            <div class="card p-2">
                                <div class="row">
                                    <div class="col-md-5">
                                        <div class="d-flex flex-row" style="height:100%">
                                            <div class="p-1 align-self-center">
                                                <img class="img-thumb" :src="pizza.imagem_url" style="max-height: 72px ; max-width: 72px" >
                                            </div>
                                            <div class="p-1">
                                                <h6>{{pizza.nome}}</h6>
                                                <span style="font-weight:normal; font-size:12px">{{pizza.descricao}}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md mt-3 mt-md-0">
                                        <div class="d-flex flex-row flex-wrap justify-content-around">
                                            <div
                                                v-for="tamanho in pizza.ver_tamanhos"
                                                :key="tamanho.tamanho_id"
                                                class="d-flex flex-column justify-content-between mx-1"
                                            >
                                                <button v-bind:disabled="tamanho.disponivel==0" class="mb-0 text-center btn b-btn p-2 mb-2 rounded" @click="modalAddCarrinhoPizza(pizza.id,tamanho.tamanho_id)">{{tamanho.nome}}</button>
                                                <span v-if="tamanho.promocao" class="badge badge-pill badge-danger align-self-center">Em Promoção</span>
                                                <del v-if="tamanho.promocao"  class="align-self-center">{{'R$ '+formatarMoeda(tamanho.valor)}}</del>
                                                <span v-if="tamanho.promocao" class="align-self-center"> {{'R$ '+formatarMoeda(tamanho.promocao.valor)}}</span>
                                                <span v-else class="align-self-center"> {{'R$ '+formatarMoeda(tamanho.valor)}}</span>
                                                <span v-if="tamanho.disponivel==0" class="align-self-center"> (não disponivel)</span>
                                                <!-- <span  class="align-self-center">R$ {{formatarMoeda(produto.valor)}}</span> -->
                                            </div>




                                        </div>
                                    </div>
                                </div>


                            </div>

                    </div>


            </div>
            <div class="row flex-row-reverse my-4 ">
                <button class="btn b-btn btn-lg mx-3" @click="pesquisar('')" >Voltar para a lista completa</button>

            </div>

        </div>


        <template v-else>

        <!-- --------------------------------------------------------------------------------------------------------------------------------------------- -->
        <!-- ----------------------------------------------------------------  PROMOÇÕES  ---------------------------------------------------------------- -->
        <!-- --------------------------------------------------------------------------------------------------------------------------------------------- -->

            <div
                v-if="promocoes.length > 0"
                id="catPromocoes"
                class="pt-5 body-bd"
            >
                <div class="row mt-2 mb-4 titulo-categoria">
                    <h3 >Promoções</h3>
                </div>
                <div v-if="!carregando_prod" class="row mx-0 productlist" >
                    <div
                        v-for="produto in promocoes"
                        :key="produto.id"
                        class="col-lg-6 px-1 my-1"
                    >
                        <a @click="modalAddCarrinho(produto)">
                            <div class="card p-2">
                                <div class="d-flex flex-row" style="height:100%">
                                    <div v-if="produto.imagem_url" class="p-1 align-self-center">
                                        <img class="img-thumb" :src="produto.imagem_url" style="max-height: 72px ; max-width: 72px" >
                                    </div>
                                    <div class="p-1">
                                        <h6>{{produto.nome}}</h6>
                                        <span style="font-weight:normal; font-size:12px">{{produto.descricao}}</span>
                                    </div>
                                    <div class="p-1 ml-auto" >
                                        <div class="d-flex flex-column justify-content-end" style="width:80px; height:100%">
                                            <span v-if="produto.promocao" class="badge badge-pill badge-danger align-self-center mb-auto">Em Promoção</span>
                                            <del v-if="produto.promocao" class="align-self-center mb-2">R$ {{formatarMoeda(produto.valor)}}</del>
                                            <span v-if="produto.promocao" class="align-self-center">R$ {{formatarMoeda(produto.promocao.valor)}}</span>
                                            <span v-else class="align-self-center">R$ {{formatarMoeda(produto.valor)}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
                <div v-else class="text-center">
                    <div class="spinner-border text-info my-5" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>

            </div>

            <!-- --------------------------------------------------------------------------------------------------------------------------------------------- -->
            <!-- ----------------------------------------------------------------  DESTAQUES  ---------------------------------------------------------------- -->
            <!-- --------------------------------------------------------------------------------------------------------------------------------------------- -->

            <div v-if="produtos.filter(produto => produto.destaque == 1).length > 0 || montarPratos.filter(prato => prato.ativado == 1).length > 0 " class="pt-5 body-bd" >
                <div class="row mt-2 mb-4 titulo-categoria">
                    <h3 >Destaques</h3>
                </div>

                <div class="row mx-0 productlist" >
                    <div
                        v-for="produto in produtos.filter(produto => produto.destaque == 1)"
                        :key="produto.id"
                        class="col-lg-12 px-1 my-1"
                    >

                        <a @click="modalAddCarrinho(produto)">
                            <div class="card p-2">
                                <div class="d-sm-flex flex-row" style="height:100%">
                                    <div class="p-1 align-self-center text-center">
                                        <div v-if="produto.imagem_url" class="p-1 align-self-center">
                                            <img class="img-thumb" :src="produto.imagem_url" style="max-height: 170px ; max-width: 170px" >
                                        </div>
                                    </div>
                                    <div class="p-1">
                                        <h4>{{produto.nome}}</h4>
                                        <span style="font-weight:normal; font-size:16px">{{produto.descricao}}</span>
                                    </div>
                                    <div class="p-1 ml-auto" >
                                        <div class="d-sm-flex flex-column justify-content-center">
                                            <span v-if="produto.promocao" class="badge badge-pill badge-danger align-self-center mb-2">Em Promoção</span>
                                            <del v-if="produto.promocao" class="align-self-center mb-2">R$ {{formatarMoeda(produto.valor)}}</del>
                                            <span v-if="produto.promocao" class="align-self-center" style="font-weight:normal; font-size:18px">R$ {{formatarMoeda(produto.promocao.valor)}}</span>
                                            <span v-else class="align-self-center" style="font-weight:normal; font-size:18px">R$ {{formatarMoeda(produto.valor)}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>

            <!-- ------------------------------------------------------------------------------------------------------------------------------------------ -->
            <!-- ----------------------------------------------------------------  CLONES  ---------------------------------------------------------------- -->
            <!-- ------------------------------------------------------------------------------------------------------------------------------------------ -->


            <div
                v-if="clones.length > 0"
                id="catClonePizza"
                class="pt-5 body-bd"
            >
                <div class="row mt-2 mb-4 titulo-categoria">
                    <h3 >Clones</h3>
                </div>
                <div class="row mx-0 productlist" >
                    <div
                        v-for="clone in clones"
                        :key="clone.id"
                        class="col-lg-12 px-1 my-1"
                    >

                        <a @click="modalAddCarrinhoClone(clone)">
                            <div class="card p-2">
                                <div class="d-flex flex-row" style="height:100%">
                                    <div class="p-1 align-self-center">
                                        <img class="img-thumb" src="/images/clone.png" style="max-height: 170px ; max-width: 170px" >
                                    </div>
                                    <div class="p-1">
                                        <h4>{{clone.nome}}</h4>
                                        <span style="font-weight:normal; font-size:12px">{{clone.descricao}}</span>
                                    </div>
                                    <div class="p-1 ml-auto" >
                                        <div class="d-flex flex-column justify-content-end" style="width:80px; height:100%">
                                            <span class="align-self-center">R$ {{formatarMoeda(clone.valor)}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>


            <!-- ------------------------------------------------------------------------------------------------------------------------------------------ -->
            <!-- ----------------------------------------------------------------  PIZZAS  ---------------------------------------------------------------- -->
            <!-- ------------------------------------------------------------------------------------------------------------------------------------------ -->

            <div
                v-if="pizzas.length > 0"
                id="catPizza"
                class="pt-5 body-bd"
            >
                <div class="row mb-4 mt-2 titulo-categoria">
                    <h3 >Pizzas</h3>
                </div>
                <div class="row mx-0 productlist" >
                    <div
                        v-for="pizza in pizzas"
                        :key="pizza.id"
                        class="col-lg-12 px-1 my-1"
                    >

                        <div class="card p-2">
                            <div class="row">
                                <div class="col-md-5">
                                    <div class="d-flex flex-row" style="height:100%">
                                        <div v-if="pizza.imagem_url" class="p-1 align-self-center">
                                            <img class="img-thumb" :src="pizza.imagem_url" style="max-height: 72px ; max-width: 72px" >
                                        </div>
                                        <div class="p-1">
                                            <h6>{{pizza.nome}}</h6>
                                            <span style="font-weight:normal; font-size:12px">{{pizza.descricao}}</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md mt-3 mt-md-0">
                                    <div class="d-flex flex-row flex-wrap justify-content-around">
                                        <div
                                            v-for="tamanho in pizza.ver_tamanhos"
                                            :key="tamanho.tamanho_id"
                                            class="d-flex flex-column justify-content-between mx-1"
                                        >
                                            <template v-if="tamanho.nao_mostrar!=1">

                                                <button v-bind:disabled="tamanho.disponivel==0" class="mb-0 text-center btn b-btn p-2 mb-2 rounded" @click="modalAddCarrinhoPizza(pizza.id,tamanho.tamanho_id)">{{tamanho.nome}}</button>
                                                <span v-if="tamanho.promocao" class="badge badge-pill badge-danger align-self-center">Em Promoção</span>
                                                <del v-if="tamanho.promocao"  class="align-self-center">{{'R$ '+formatarMoeda(tamanho.valor)}}</del>
                                                <span v-if="tamanho.promocao" class="align-self-center"> {{'R$ '+formatarMoeda(tamanho.promocao.valor)}}</span>
                                                <span v-else class="align-self-center"> {{'R$ '+formatarMoeda(tamanho.valor)}}</span>
                                                <span v-if="tamanho.disponivel==0" class="align-self-center"> (não disponivel)</span>
                                                <!-- <span  class="align-self-center">R$ {{formatarMoeda(produto.valor)}}</span> -->

                                            </template>
                                        </div>




                                    </div>
                                </div>
                            </div>


                        </div>

                    </div>





                </div>

            </div>

            <!-- ----------------------------------------------------------------------------------------------------------------------------------------------------- -->
            <!-- ----------------------------------------------------------------  LISTA DE PRODUTOS  ---------------------------------------------------------------- -->
            <!-- ----------------------------------------------------------------------------------------------------------------------------------------------------- -->

            <div
                v-for="categoria in categorias.filter(categoria => categoria.disponivel == 1)"
                :key="categoria.id"
                :id="'cat'+categoria.id"
                class="pt-5 body-bd"
            >
                <div class="row mb-4 mt-2 titulo-categoria">
                    <h3 >{{toTitleCase(categoria.nome)}}</h3>
                </div>
                <div v-if="!carregando_prod" class="row mx-0 productlist" >
                    <div
                        v-for="produto in produtos.filter(produto => produto.categoria_id == categoria.id)"
                        :key="produto.id"
                        class="col-lg-6 px-1 my-1"
                    >
                        <a @click="modalAddCarrinho(produto)">
                            <div class="card p-2">
                                <div class="d-flex flex-row" style="height:100%">
                                    <div v-if="produto.imagem_url" class="p-1 align-self-center">
                                        <img class="img-thumb" :src="produto.imagem_url" style="max-height: 72px ; max-width: 72px" >
                                    </div>
                                    <div class="p-1">
                                        <h6>{{produto.nome}}</h6>
                                        <span style="font-weight:normal; font-size:12px">{{produto.descricao}}</span>
                                    </div>
                                    <div class="p-1 ml-auto" >
                                        <div class="d-flex flex-column justify-content-end" style="width:80px; height:100%">
                                            <span v-if="produto.promocao" class="badge badge-pill badge-danger align-self-center mb-auto">Em Promoção</span>
                                            <del v-if="produto.promocao" class="align-self-center mb-2">R$ {{formatarMoeda(produto.valor)}}</del>
                                            <span v-if="produto.promocao" class="align-self-center">R$ {{formatarMoeda(produto.promocao.valor)}}</span>
                                            <span v-else class="align-self-center">R$ {{formatarMoeda(produto.valor)}}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
                <div v-else class="text-center">
                    <div class="spinner-border text-info my-5" role="status">
                        <span class="sr-only">Loading...</span>
                    </div>
                </div>

            </div>


        </template>





    </div>

    <div v-else class="text-center">
        <div class="spinner-border text-info my-5" role="status">
            <span class="sr-only">Loading...</span>
        </div>
    </div>







</div>
</template>

<script>
import api from "../service/api";
import helper from '../helper.js'

export default {
    data () {
        return {
            carregando_prod:false,
            carregando_cat:false,
            produtos : [],
            promocoes: [],
            categorias: [],
            montarPratos: [],
            pizzas: [],
            clones: [],
            filtro_categoria:'',
            produto_ativo: {},
            busca:'',
            campo_busca:''
        }
    },

    methods: {
        pesquisar(campo){
            this.busca = campo
        },

        filtrarProduto(nome){
            var regex = new RegExp(this.busca, "gi");
            if (nome.match(regex)) {
                return true;
            }else{
                return false;
            }
        },

        openMenu(){
            this.busca = "";
            this.campo_busca = "";
            if(this.$refs.LeftDrawer.active){
                this.$refs.LeftDrawer.close();
            }else{
                this.$refs.LeftDrawer.open();
            }
        },

        async carregarProdutos(){
            this.carregando_prod = true
            await api
            .get('/produtos-all')
            .then((response) => {
                this.produtos = response.data.filter(produto => produto.dia_disponivel==true && produto.categoria.disponivel==1 );
                this.promocoes = response.data.filter(produto => produto.promocao);

            })
            this.carregando_prod = false;
        },

        async carregarCategorias(){
            this.carregando_cat = true
            await api
            .get('/categorias')
            .then(response => (this.categorias = response.data.filter(categoria => categoria.disponivel == 1)))
            this.carregando_cat = false;
        },

        async carregarPizzas(){
            this.carregando_prod = true
            await api
            .get('/pizzas/sabores')
            .then((response) => {
                this.pizzas = response.data;

            })
            this.carregando_prod = false;
        },

        async carregarClones(){
            this.carregando_prod = true
            await api
            .get('/clones')
            .then((response) => {

                let clonesBd = response.data.data;
                let dia = new Date()
                let diaSemana = dia.getDay();
                let horaAtual =  dia.toLocaleTimeString();



                clonesBd.forEach(clone => {
                    clone.dias = clone.dias.split(',').map(Number);
                });

                this.clones = clonesBd.filter(clone => clone.dias.includes(diaSemana)&&(clone.todahora==1||(clone.hora_inicial<horaAtual&&clone.hora_final>horaAtual)));

            })
            this.carregando_prod = false;
        },

        async carregarPratos(){
            this.carregando = true;
            await api
            .get('/montarprato')
            .then(response => (this.montarPratos = response.data))

            this.carregando = false
        },



        toTitleCase: helper.toTitleCase,

        async modalAddCarrinho(prod){
            let obj1 = JSON.parse(JSON.stringify(prod));
            await this.$store.dispatch('editarProdutoCarrinho', null).then();
            await this.$store.dispatch('atualizarProdutoAtivo', obj1).then();
            await this.$store.dispatch('showModalAddCarrinho').then();
            $('#addCarrinho').modal('show');
        },

        async modalAddCarrinhoClone(clone){
            let obj1 = JSON.parse(JSON.stringify(clone));
            await this.$store.dispatch('atualizarCloneAtivo', obj1).then();
            // await this.$store.dispatch('showModalAddCarrinho').then();
            $('#addCarrinhoClone').modal('show');
        },

        async modalAddCarrinhoPizza(sabor,tamanho){
            // let obj1 = JSON.parse(JSON.stringify(sabor));
            let obj1 = {
                sabor_id: sabor,
                tamanho_id: tamanho
            };
            await this.$store.dispatch('atualizarPizzaAtiva', obj1).then();
            // await this.$store.dispatch('showModalAddCarrinho').then();
            $('#addCarrinhoPizza').modal('show');
        },

        formatarMoeda(valor){
              return valor.replace(".",",")
        },





    },

    mounted () {

        this.carregarProdutos();
        this.carregarCategorias();
        this.carregarPizzas();
        this.carregarClones();
        this.carregarPratos()
    },

}
</script>

<style scoped>

del {
    font-size: 0.8rem;
    color: red;
}

.card {
    height: 100%;
    background-image: linear-gradient(to bottom, rgba(0,0,0,0),rgba(0,0,0,0), rgba(0,0,0,0.07));
    border: 1px solid rgba(0, 0, 0, 0.20);
    border-radius: 0.8rem;
}

.productlist a{
    text-decoration: none;
    cursor: pointer;
}

.productlist .card:hover{
    box-shadow: 2px 2px 6px 0px #a7a7a7;
}

.titulo-categoria{
    border-bottom: 5px solid var(--btnbg3);
}

.titulo-categoria h3 {
    padding: 8px 20px;
    color: var(--btntxt3);
    background:  var(--btnbg3);
    margin-bottom: -1px;
    border-top-right-radius: 10px;
    font-family: 'Lobster', cursive;
    text-shadow: -1px 1px 4px black;
}

.navbar-produtos {

  /* background-color:#786565; */
  position: -webkit-sticky; /* Safari */
  position: sticky;
  top: 0;
  z-index: 10;
}

.active {
  background-color: var(--bg3);
}

.img-thumb{
    border-radius: 0.25rem;
    border:1px solid rgba(0, 0, 0, 0.20);
    padding: 00.12rem;
    box-shadow: -3px 2px 6px 1px #d3d3d3;
}

.drawer ul{
    list-style: none;
}








</style>
